import { render, staticRenderFns } from "./config.vue?vue&type=template&id=66d7fd85"
import script from "./config.vue?vue&type=script&lang=js"
export * from "./config.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66d7fd85')) {
      api.createRecord('66d7fd85', component.options)
    } else {
      api.reload('66d7fd85', component.options)
    }
    module.hot.accept("./config.vue?vue&type=template&id=66d7fd85", function () {
      api.rerender('66d7fd85', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modulestore/module/3-2-graphic-list-2/config.vue"
export default component.exports